/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SBE SMS API
 * SMS API. AccessTokenGuard 보호 라우트는 Authorization: Bearer <jwt> 가 필요.
 * OpenAPI spec version: 1.0
 */

export type MessageStatus = typeof MessageStatus[keyof typeof MessageStatus];


export const MessageStatus = {
  Saved: 'Saved',
  Charged: 'Charged',
  Scheduled: 'Scheduled',
  Batched: 'Batched',
  Sent: 'Sent',
  Completed: 'Completed',
  PartialFailure: 'PartialFailure',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
} as const;
